/** The operational state of a trap position. */
export enum TrapPositionStatus {
	Suggested = "suggested",
	Confirmed = "confirmed",
	Active = "active",
	Inactive = "inactive",
}

/** How a trap measurement was obtained. */
export enum MeasurementSource {
	Lens = "lens",
	Manual = "manual",
	/** Imported from an external lab report PDF. */
	Import = "import",
}

/** Material type for trap limit configuration. */
export enum MaterialType {
	Metal = "metal",
	NonMetal = "non_metal",
	Fiber = "fiber",
}

/** Which geometric limit applies to the material. */
export enum LimitType {
	FeretMax = "feretMax",
	FeretMin = "feretMin",
	InCircle = "inCircle",
}
